import { InjectionToken } from '@angular/core';

export const AppName = new InjectionToken('appName');
export const AppUrl = new InjectionToken('appUrl');
